export const footerContent = {
    fr: {
        blurb: "Nous offrons les meilleurs services IPTV. Notre service est simple, rapide et fiable. Vous pouvez profiter de vos chaînes préférées sur n'importe quel appareil, où que vous soyez.",
        quickLinks: 'Liens rapides',
        refundLink: 'Politique de Remboursement',
        privacyLink: 'Politiques De Confidentialité',
        termsLink: "Conditions Générales d'Utilisation",
        contact: 'Contact',
        weAccept: 'Nous acceptons',
        copyright: '© LIGUEE1 - contact@liguee1.com',
    },
    es: {
        blurb: 'Ofrecemos los mejores servicios de IPTV. Nuestro servicio es simple, rápido y fiable. Puedes disfrutar de tus canales favoritos en cualquier dispositivo, estés donde estés.',
        quickLinks: 'Enlaces rápidos',
        refundLink: 'Política de Reembolso',
        privacyLink: 'Política de Privacidad',
        termsLink: 'Términos y Condiciones de Uso',
        contact: 'Contacto',
        weAccept: 'Aceptamos',
        copyright: '© LIGUEE1 - contact@liguee1.com',
    },
};
